import {Apollo} from 'apollo-angular';

import { Injectable } from '@angular/core';
import {
  PortfolioProcessAnalyticsScheduleGQL,
  PortfolioProcessAnalyticsScheduleQuery,
  ParkProcessAnalyticsScheduleGQL,
  ParkProcessAnalyticsScheduleQuery,
  ProcessAnalyticsStartDatesGQL,
  ProcessAnalyticsStartDatesQuery,
  ProcessAnalyticsStartDatesParkGQL,
  ProcessAnalyticsStartDatesParkQuery
} from '../../graphql';

import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ProcessesAnalyticsService {

  constructor(
      private apollo: Apollo,
      private parkProcessAnalyticsScheduleGQL: ParkProcessAnalyticsScheduleGQL,
      private portfolioProcessAnalyticsScheduleGQL: PortfolioProcessAnalyticsScheduleGQL,
      private processAnalyticsStartDatesGQL: ProcessAnalyticsStartDatesGQL,
      private processAnalyticsStartDatesParkGQL: ProcessAnalyticsStartDatesParkGQL
  ) {
  }

  public processAnalyticsPortfolioData(startTs: number, endTs: number, id: string) {
    return this.apollo.use('v2_http').query({
      query: this.portfolioProcessAnalyticsScheduleGQL.document,
      variables: { startTs, endTs, _id_process: id },
      fetchPolicy: 'no-cache'
    }).pipe(map((e: Apollo.QueryResult<PortfolioProcessAnalyticsScheduleQuery>) => {
      return e.data.PORTFOLIO;
    }));
  }

  public processAnalyticsParkData(startTs: number, endTs: number, id: string, parkId: string) {
    return this.apollo.use('v2_http').query({
      query: this.parkProcessAnalyticsScheduleGQL.document,
      variables: { startTs, endTs, _id_process: id, parkId },
      fetchPolicy: 'no-cache'
    }).pipe(map((e: Apollo.QueryResult<ParkProcessAnalyticsScheduleQuery>) => {
      return e.data.PARKS[0];
    }));
  }

  public processAnalyticsStartDates(id: string) {
    return this.apollo.use('v2_http').query({
      query: this.processAnalyticsStartDatesGQL.document,
      variables: { _id_process: id },
      fetchPolicy: 'no-cache'
    }).pipe(map((e: Apollo.QueryResult<ProcessAnalyticsStartDatesQuery>) => {
      const data = e.data.PORTFOLIO.DATA.TABLE;
      return [...data.DATA_LGB.logbook_monthly, ...data.DATA_PLN.planned_events];
    }));
  }

  public processAnalyticsStartDatesPark(id: string, parkId: string) {
    return this.apollo.use('v2_http').query({
      query: this.processAnalyticsStartDatesParkGQL.document,
      variables: { _id_process: id, parkId },
      fetchPolicy: 'no-cache'
    }).pipe(map((e: Apollo.QueryResult<ProcessAnalyticsStartDatesParkQuery>) => {
      const data = e.data.PARKS[0].DATA.TABLE;
      return [...data.DATA_LGB.logbook_monthly, ...data.DATA_PLN.planned_events];
    }));
  }

}
